import React, { useEffect, useState } from "react";
import Navbar from "../components/Cripsr/NavbarCrispr";
import NarrativeSection from "../components/phones/NarrativeSection";
import EndOfStoryNav from "../components/phones/EndOfStoryNav";
import BecauseScienceFooter from "../components/phones/BecauseScienceFooter";
// GutCheckPage.jsx (top)
import ScreenTimeQuiz from "../components/phones/ScreenTimeQuiz";

import chart_10 from "../assets/images/chartoptions/BS_EP1_Health1.png";
import chart_15 from "../assets/images/chartoptions/BS_EP1_Health2.png";
import chart_20 from "../assets/images/chartoptions/BS_EP1_Health3.png";
import chart_25 from "../assets/images/chartoptions/BS_EP1_Health4.png";
import chart_30 from "../assets/images/chartoptions/BS_EP1_Health5.png";
import chart_35 from "../assets/images/chartoptions/BS_EP1_Health6.png";
import chart_40 from "../assets/images/chartoptions/BS_EP1_Health7.png";

// Replace these thumbs/banners with your real assets when ready
import phonesThumb from "../assets/images/hero/Hero Images.png";
import siliconThumb from "../assets/images/hero/Hero Images-02.png";
import foeThumb from "../assets/images/hero/Hero Images-04.png"
import privacyThumb from "../assets/images/hero/Hero Images-01.png";
import rechargingThumb from "../assets/images/hero/Hero Images-05.png";
import gutThumb from "../assets/images/hero/Hero Images-03.png";
import MatthewBuman from "../assets/images/chartoptions/MatthewBuman.jpg";




import HorizontalPanStage from "../components/phones/HorizontalPanStage";

import slide1 from "../assets/images/phones/BS_EP1_Health_slider-04.png";
import slide2 from "../assets/images/phones/BS_EP1_Health_slider-05.png";
import slide3 from "../assets/images/phones/BS_EP1_Health_slider-06.png";
import slide4 from "../assets/images/phones/BS_EP1_Health_slider-07.png";
import ArticleCredits from "../components/phones/ArticleCredits";

const navLinks = [
    { label: "We love our phones", href: "/phones" },
    { label: "From stone to silicon", href: "/phones" },
    { label: "Friend or foe", href: "/phones/friendorfoe" },
    { label: "The privacy burden", href: "/phones/privacyburden" },
    { label: "Gut check", href: "/phones/gutcheck" },
    { label: 'Recharging', href: '/phones/recharging' },
];



export default function GutCheckPage() {
    const [isShrunk, setIsShrunk] = useState(false);
    useEffect(() => {
        const onScroll = () => setIsShrunk(window.scrollY > 0);
        onScroll();
        window.addEventListener("scroll", onScroll);
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <div className="relative w-full bg-white">
            {/* Navbar */}
            <Navbar isShrunk={isShrunk} navLinks={navLinks} />

            {/* Opener (audio + article body). No big hero image to match your screenshot */}
            <NarrativeSection
                id="gut-check"
                containerWidth="max-w-md"
                padY="py-10"
                centeredImage={{
                    src: gutThumb,
                    alt: "Friend or foe hero",
                    widthClass: "w-[90%] sm:w-[85%]",
                }}
                content={[
                    // Audio block first (kept inside content so we don't change the component)
                    <div key="audio" className="text-center mb-8">
                        <p className="uppercase text-gray-500 text-xs tracking-wide mb-2">
                            Listen to this episode
                        </p>
                        <div className="flex justify-center">
                            <audio controls className="w-full max-w-md">
                                <source src="/audio/gut-check.mp3" type="audio/mpeg" />
                                Your browser does not support the audio element.
                            </audio>
                        </div>
                    </div>,

                    // Article copy (use/replace with your final text)
                    `There you are sitting on your sofa and staring in the face of at least an hour of free time to indulge in whatever it is you want. You have that book you’ve been dying to read. Spare. But as you consciously reach for it and decide that today is the day you will finally get all the juicy insights on the real British monarchy, your cell phone buzzes. Then it vibrates. And then a ping, a noise you had not heard before. You reach for it instead of the book.`,
                    `In a world of rapidly evolving technological advances, most people seem to be in love with cell phones and other smart tech. We integrate it into our lives. We use it to substitute for other substantial activities, like exercise or a mind-building hobby, perhaps. Smart tech is there. It beckons us and it does so with no sense of time or place. But is it possible to live outside of its influence? And if it is, what health advantages would that provide?`,
                    `Matt Buman has been studying the physical effects of smartphone use for years. A current 16-week intervention for adults centers on showing people what their tech use adds up to in a typical day and then builds out healthy interventions to raise awareness and correct typical behaviors. It focuses on the effects screen time behavior has on sleep patterns, physical activities and the time devoted to technology such as smartphones and watches. Buman utilizes the lessons learned from years of working with athletes to leverage technology that can help everyone be more aware of their use of screens.`,
                    `And ironically, his team uses an app for that.`,
                    `“Technology is just ubiquitous in our society,” says Buman, director for Precision Health Research Initiatives at Arizona State University’s College of Health Solutions. “We have amazing technology in our pockets, on our wrists and can we leverage those devices for good and not evil to help people be healthier.”`,

                    // Pull quote exactly where you want it
                    {
                        type: "quote",
                        content:
                            "We're watching more screens than we were just prior to COVID.",
                        tone: "primary",
                        align: "left",
                    },
                    `They come to Buman, very much aware of how they love their screen time and yet they are actively trying to make some changes. He’s not trying to convince someone that they're spending too much time on their screen, Buman says people know coming in that they need healthy limits but they simply don't have the tools to do it.`,
                    `The average American spends two-and-a-half hours a day staring at a screen, whether that be a computer monitor, a cell phone, tablet or television. And Buman says, the pandemic only fueled this trend.`
                ]}
            />
            <ScreenTimeQuiz
                key="quiz1"
                options={["1.0 or <", "1.5", "2.0", "2.5", "3.0", "3.5", "4.0 or >"]}
                imagesByOption={{
                    "1.0 or <": chart_10,
                    "1.5": chart_15,
                    "2.0": chart_20,
                    "2.5": chart_25,
                    "3.0": chart_30,
                    "3.5": chart_35,
                    "4.0 or >": chart_40,
                }}
                maxWidth="max-w-3xl"
            />,

            <NarrativeSection
                containerWidth="max-w-md"
                padY="py-8"
                content={[
                    // BLUE QUESTION CARD


                    // Quote + copy (from your screenshot)
                    `“We're watching more screens than we were just prior to COVID,” says Buman. “So certainly, smartphones and the proliferation of different technologies creates greater opportunity and ease to spend time on screens.”`,

                    <h3 key="carrot" className="text-blue-700 font-bold text-xl sm:text-3xl mt-4">
                        Carrot and stick
                    </h3>,
                    `Now, researchers are deploying different tactics such as reminder texts to let participants know when they are approaching their targeted screen time goals. That approach, he says, seems to be more palatable than the full “lockout” mode that takes place when participants blow past all the warning signs and reach their screen time limits.`,
                    `“What we know from the little literature on this topic is that that one is the most effective: when we just limit it.” It helps people manage their time, he says, when they know that there’s a real key thing on the horizon, the threat of being locked out.`,
                    `But if you do get locked out, Buman says, there are ways to earn back screen time by being more physically active.`,
                    `Researchers want to learn more about how these behavioral facets interact with each other.`,
                    `“Some individuals might find the lockout really difficult to adhere to, but if they're given text reminders and encouragement along the way, then they may be more susceptible to be okay with that lockout condition,” Buman says. “The ultimate goal is to develop one app that provides just the right kind of intervention, the right combination of these techniques to really help maximize how much time people are able to reduce watching screens.”`,
                    `Buman says it’s the prolonged periods of sitting while consuming our screen time that is detrimental to our health. The long sedentary periods can have serious health implications such as cardiovascular disease, diabetes and even early mortality. The reason why, Buman says, is that  people typically consume high fat, high sugar foods while watching screens and that can have a serious impact on health on a molecular level.`,


                ]}
            />


            <NarrativeSection
                containerWidth="max-w-md"
                padY="py-8"
                centeredImage={{
                    src: MatthewBuman,
                    alt: "Friend or foe hero",
                    widthClass: "w-[50%] sm:w-[45%]",
                }}
                content={[
                    `“Some individuals might find the lockout really difficult to adhere to, but if they're given text reminders and encouragement along the way, then they may be more susceptible to be okay with that lockout condition,” Buman says. “The ultimate goal is to develop one app that provides just the right kind of intervention, the right combination of these techniques to really help maximize how much time people are able to reduce watching screens.”`,
                    `Buman says it’s the prolonged periods of sitting while consuming our screen time that is detrimental to our health. The long sedentary periods can have serious health implications such as cardiovascular disease, diabetes and even early mortality. The reason why, Buman says, is that  people typically consume high fat, high sugar foods while watching screens and that can have a serious impact on health on a molecular level.`,
                    <h3 key="carrot" className="text-blue-700 font-bold text-xl sm:text-3xl mt-4">
                        Feeding the beast within
                    </h3>,
                    `Buman and colleagues Corrie Whisner and Meg Bruening recently completed one of the first studies to look at how smartphone use affects our molecular physiology. They found smartphones not only tap into our unquenchable, hard-wired desire for more, but can also begin to alter our metabolism.`,
                    `Whisner typically studies maternal health and the bacteria that lives in our gut, microbiome. She joined Buman and Bruening to take a deeper dive to learn more about how screen time affects sleep and overall health.`,
                    `“Most people have really only looked at how screen time affects the brain,” says Whisner, an associate professor with the College of Health Solutions. “Meg had just began a study on how social networks affect health behaviors of college freshmen living in the dorms.`,
                    `In the past decade, scientists have been fascinated with the influence that bacteria, which far outnumber the number of cells in our body, have on human health.`
                ]}
            />

            <HorizontalPanStage
                images={[
                    { src: slide1, alt: "stage part 1" },
                    { src: slide2, alt: "stage part 2" },
                    { src: slide3, alt: "stage part 3" },
                    { src: slide4, alt: "stage part 4" },
                ]}
                stageHeight="h-screen"         // (not used directly in this version)
                breakpointPx={780}
                spacerExtra={260}
                navHeight={20}                 // <-- set this if your navbar is fixed and 64px tall (change to actual)
            />

            <NarrativeSection
                containerWidth="max-w-md"
                padY="py-8"
                content={[

                    `Whisner says scientists have identified trillions of microbes in our gut and describes them as a huge arsenal of little friends that can send signals back and forth like a beautiful symphony.`,
                    `“So one thing microbes can do is actually harness more fuel from the things that we eat. So whenever we go to the bathroom, we lose some energy and things just pass through faster than we can use it all.”`,
                    `“But in those particular students who had more screen time, they may actually be getting more calories out of their food through protein fermentation. Generally protein fermentation is not a good thing. It sometimes leads to detrimental or health degradative compounds.”`,
                    `“An easy way to think about it is the old adage that ‘we are, what we eat,’ and everything that we eat is made of molecules,” says Whisner.`,
                    `Buman adds that screen time is habitual and is a proponent of in the moment reminders to help keep the day moving along. Recognizing that even positive, healthy things can be an addiction, Buman is hesitant to label tech habits an “addiction.”`,
                    `“We don't know enough about screen time to know whether it has the same chemical effects that substance use has,” says Buman. I think that's a common thing between something like substance use and screen time. But whether it has some of those physical biological components, I think that is still unclear.”`,
                ]}
            />

            <ArticleCredits
                lines={[
                    "Written by by Gabriella Kemp",
                    "Illustrations by Alex Davis",
                    "Audio narration by Gabriella Kemp",
                    "Sound design by Christopher Goulet",
                ]}
            />

            {/* Next + More (adjust routes/images as needed) */}
            <EndOfStoryNav
                nextChapter={{
                    href: "/phones/recharging",
                    title: "Recharging",
                    imageSrc: rechargingThumb,
                    imageAlt: "Recharging banner",
                }}
                more={[
                    { href: "/phones", title: "We love our phones", imageSrc: phonesThumb },
                    { href: "/phones/stoneandsilicon", title: "From stone to silicon", imageSrc: siliconThumb },
                    { href: "/phones/friendorfoe", title: "Friend or foe", imageSrc: foeThumb },
                    { href: "/phones/privacy-burden", title: "The privacy burden", imageSrc: privacyThumb },
                ]}
            />

            <BecauseScienceFooter />
        </div>
    );
}
